import { render, staticRenderFns } from "./chat-right.vue?vue&type=template&id=6485d52c&scoped=true"
import script from "./chat-right.vue?vue&type=script&lang=js"
export * from "./chat-right.vue?vue&type=script&lang=js"
import style0 from "./chat-right.vue?vue&type=style&index=0&id=6485d52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6485d52c",
  null
  
)

export default component.exports